/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminV1OrganizationsPaymentsLogStatisticsRetrieveParams,
  PaymentsLogStatistics
} from '.././model';

import adminV1OrganizationsPaymentsLogStatisticsRetrieveMutator from '../../shared/services/axios-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Payments-log statistics for one organization, scoped to the caller's hierarchy.
 * @summary Payments-log statistics for one organization, scoped to the caller's hierarchy.
 */
export const adminV1OrganizationsPaymentsLogStatisticsRetrieve = (
    organizationId: number,
    params?: AdminV1OrganizationsPaymentsLogStatisticsRetrieveParams,
 options?: SecondParameter<typeof adminV1OrganizationsPaymentsLogStatisticsRetrieveMutator<PaymentsLogStatistics>>,) => {
      return adminV1OrganizationsPaymentsLogStatisticsRetrieveMutator<PaymentsLogStatistics>(
      {url: `/api/admin/v1/organizations/${organizationId}/payments/log/statistics/`, method: 'GET',
        params
    },
      options);
    }
  export type AdminV1OrganizationsPaymentsLogStatisticsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsPaymentsLogStatisticsRetrieve>>>
